import {
	IGetDishesShortBySubCategoryIdsArguments,
	IGetDishesShortArgs,
	IGetDishesByRestaurantIdsAndSubcategoryIdsArgs,
	ICreateDish,
	ICreateDishV2,
	IUpdateDish,
	IUpdateDishV2,
	IGetPaginatedDishes,
	IGetPaginatedDishesByCustomerV2,
	IGetPaginatedDishesByRestaurantV2,
	IGetDishPositionListArguments,
	IGetDishPositionListArgumentsV2,
	IGetDishPositionChainsArguments,
	IGetDishPositionChainsArgumentsV2,
	IUpdateDishPositions,
	IUpdateDishPositionsV2,
	IGetDishRestaurantPropertiesArguments,
	IUpdateDishRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForDish,
	IGetPaginatedDishesForAssign,
	IGetListRestaurantsForAssignDishesArguments,
	IGetSubcategoriesByIDsCategoriesArguments,
	IGetDishesByIDsSubcategoriesArguments,
	IAssignDish,
	IAssignDishToSubcategories,
	ICreatePortion,
	IGetDishRestaurantPortionsArguments,
	IToggleDishPortionsEnabledArguments,
	IDeleteDishPortionArguments,
	IUpdatePortion,
	IGetPortionPositionListArguments,
	IUpdatePortionPositions,
} from 'types';
import {
	serviceGetDishInfo,
	serviceGetDishInfoV2,
	serviceGetDishesShortBySubCategoryId,
	serviceGetDishesShortBySubCategoryIdV2,
	serviceGetDishesShortBySubCategoryIds,
	serviceGetDishesShortByCustomerId,
	serviceGetDishesShortByRestaurantId,
	serviceGetDishesByRestaurantIdsAndSubcategoryIds,
	serviceCreateDish,
	serviceCreateDishV2,
	serviceUpdateDish,
	serviceUpdateDishV2,
	serviceGetPaginatedDishes,
	serviceGetPaginatedDishesByCustomerV2,
	serviceGetPaginatedDishesByRestaurantV2,
	serviceDeleteDish,
	serviceDeleteDishV2,
	serviceGetDishPositionList,
	serviceGetDishPositionListV2,
	serviceGetDishPositionsChains,
	serviceGetDishPositionsChainsV2,
	serviceUpdateDishPositions,
	serviceUpdateDishPositionsV2,
	serviceGetDishRestaurantProperties,
	serviceUpdateDishRestaurantProperties,
	serviceUpdateDishRestaurantPropertiesAsPatch,
	serviceGetPaginatedDishesForAssign,
	serviceGetPaginatedDishesForAssignV2,
	serviceGetListRestaurantsForAssignDishes,
	serviceGetListRestaurantsForAssignDishesV2,
	serviceGetCategoriesByIDRestaurantForAssignDishes,
	serviceGetCategoriesByIDRestaurantForAssignDishesV2,
	serviceGetSubcategoriesByIDsCategoriesForAssignDishes,
	serviceGetSubcategoriesByIDsCategoriesForAssignDishesV2,
	serviceGetDishesByIDsSubcategoriesForAssignDishes,
	serviceGetDishesByIDsSubcategoriesForAssignDishesV2,
	serviceAssignDish,
	serviceAssignDishV2,
	serviceAssignDishToSubcategories,
	serviceAssignDishToSubcategoriesValidate,
	serviceUpdateRestaurantsInDish,
	serviceGetDishRestaurantPortions,
	serviceToggleDishPortionsEnabled,
	serviceDeletePortion,
	serviceGetDishPortionInfo,
	serviceCreatePortion,
	serviceUpdatePortion,
	serviceGetPortionPositionList,
	serviceGetPortionPositionChains,
	serviceUpdatePortionPositions,
	serviceGetDishPhotos,
} from 'services/api/dishes';
import { createAppErrorMessage } from 'utils/helpers';

// Menu v1
const getDishInfo = async (dishID: string) => {
	try {
		const response = await serviceGetDishInfo(dishID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getDishInfoV2 = async (dishID: string) => {
	try {
		const response = await serviceGetDishInfoV2(dishID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getDishesShortBySubCategoryId = async (subCategoryId: string) => {
	try {
		const response = await serviceGetDishesShortBySubCategoryId(subCategoryId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getDishesShortBySubCategoryIdV2 = async (subCategoryId: string) => {
	try {
		const response = await serviceGetDishesShortBySubCategoryIdV2(subCategoryId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getDishesShortBySubCategoryIds = async (args: IGetDishesShortBySubCategoryIdsArguments) => {
	try {
		const response = await serviceGetDishesShortBySubCategoryIds(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getDishesShortByCustomerId = async (args: IGetDishesShortArgs) => {
	try {
		const response = await serviceGetDishesShortByCustomerId(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getDishesShortByRestaurantId = async (restaurantId: string) => {
	try {
		const response = await serviceGetDishesShortByRestaurantId(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getDishesByRestaurantIdsAndSubcategoryIds = async (args: IGetDishesByRestaurantIdsAndSubcategoryIdsArgs) => {
	try {
		const response = await serviceGetDishesByRestaurantIdsAndSubcategoryIds(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

// Menu v1
const createDish = async (data: ICreateDish) => {
	try {
		await serviceCreateDish(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const createDishV2 = async (data: ICreateDishV2) => {
	try {
		const response = await serviceCreateDishV2(data);
		return response;
	} catch (err) {
		throw err;
	}
};
// Menu v2

// Menu v1
const updateDish = async (data: IUpdateDish) => {
	try {
		await serviceUpdateDish(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const updateDishV2 = async (data: IUpdateDishV2) => {
	try {
		await serviceUpdateDishV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingDish');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getPaginatedDishes = async (args: IGetPaginatedDishes) => {
	try {
		const response = await serviceGetPaginatedDishes(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getPaginatedDishesByCustomerV2 = async (args: IGetPaginatedDishesByCustomerV2) => {
	try {
		const response = await serviceGetPaginatedDishesByCustomerV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getPaginatedDishesByRestaurantV2 = async (args: IGetPaginatedDishesByRestaurantV2) => {
	try {
		const response = await serviceGetPaginatedDishesByRestaurantV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const deleteDish = async (dishID: string) => {
	try {
		await serviceDeleteDish(dishID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingDish');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const deleteDishV2 = async (dishID: string) => {
	try {
		await serviceDeleteDishV2(dishID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingDish');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getDishPositionList = async (args: IGetDishPositionListArguments) => {
	try {
		const response = await serviceGetDishPositionList(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getDishPositionListV2 = async (args: IGetDishPositionListArgumentsV2) => {
	try {
		const response = await serviceGetDishPositionListV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getDishPositionChains = async (args: IGetDishPositionChainsArguments) => {
	try {
		const response = await serviceGetDishPositionsChains(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getDishPositionChainsV2 = async (args: IGetDishPositionChainsArgumentsV2) => {
	try {
		const response = await serviceGetDishPositionsChainsV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const updateDishPositions = async (data: IUpdateDishPositions) => {
	try {
		await serviceUpdateDishPositions(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingDishPositions');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const updateDishPositionsV2 = async (data: IUpdateDishPositionsV2) => {
	try {
		await serviceUpdateDishPositionsV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingDishPositions');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getDishRestaurantProperties = async (args: IGetDishRestaurantPropertiesArguments) => {
	try {
		const response = await serviceGetDishRestaurantProperties(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateDishRestaurantProperties = async (args: IUpdateDishRestaurantProperties) => {
	try {
		const response = await serviceUpdateDishRestaurantProperties(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateDishRestaurantPropertiesAsPatch = async (data: IUpdateRestaurantPropertiesAsPatchForDish) => {
	try {
		await serviceUpdateDishRestaurantPropertiesAsPatch(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantPropertiesAsPatch');
		throw new Error(errorMessage);
	}
};

// Menu v1
const getPaginatedDishesForAssign = async (args: IGetPaginatedDishesForAssign) => {
	try {
		const response = await serviceGetPaginatedDishesForAssign(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getPaginatedDishesForAssignV2 = async (args: IGetPaginatedDishesForAssign) => {
	try {
		const response = await serviceGetPaginatedDishesForAssignV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getListRestaurantsForAssignDishes = async (args: IGetListRestaurantsForAssignDishesArguments) => {
	try {
		const response = await serviceGetListRestaurantsForAssignDishes(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getListRestaurantsForAssignDishesV2 = async (args: IGetListRestaurantsForAssignDishesArguments) => {
	try {
		const response = await serviceGetListRestaurantsForAssignDishesV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getCategoriesByIDRestaurantForAssignDishes = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoriesByIDRestaurantForAssignDishes(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getCategoriesByIDRestaurantForAssignDishesV2 = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoriesByIDRestaurantForAssignDishesV2(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getSubcategoriesByIDsCategoriesForAssignDishes = async (args: IGetSubcategoriesByIDsCategoriesArguments) => {
	try {
		const response = await serviceGetSubcategoriesByIDsCategoriesForAssignDishes(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getSubcategoriesByIDsCategoriesForAssignDishesV2 = async (args: IGetSubcategoriesByIDsCategoriesArguments) => {
	try {
		const response = await serviceGetSubcategoriesByIDsCategoriesForAssignDishesV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getDishesByIDsSubcategoriesForAssignDishes = async (args: IGetDishesByIDsSubcategoriesArguments) => {
	try {
		const response = await serviceGetDishesByIDsSubcategoriesForAssignDishes(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getDishesByIDsSubcategoriesForAssignDishesV2 = async (args: IGetDishesByIDsSubcategoriesArguments) => {
	try {
		const response = await serviceGetDishesByIDsSubcategoriesForAssignDishesV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const assignDish = async (data: IAssignDish) => {
	try {
		await serviceAssignDish(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignDish');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const assignDishV2 = async (data: IAssignDish) => {
	try {
		await serviceAssignDishV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignDish');
		throw new Error(errorMessage);
	}
};
// Menu v2

const assignDishToSubcategories = async (data: IAssignDishToSubcategories) => {
	try {
		await serviceAssignDishToSubcategories(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignDish');
		throw new Error(errorMessage);
	}
};

const assignDishToSubcategoriesValidate = async (data: IAssignDishToSubcategories) => {
	try {
		const response = await serviceAssignDishToSubcategoriesValidate(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignDish');
		throw new Error(errorMessage);
	}
};

const updateRestaurantsInDish = async (data: { dishId: string; restaurantIds: string[] }) => {
	try {
		await serviceUpdateRestaurantsInDish(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurant');
		throw new Error(errorMessage);
	}
};

const getDishPortionInfo = async (portionId: string) => {
	try {
		const response = await serviceGetDishPortionInfo(portionId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createPortion = async (data: ICreatePortion) => {
	try {
		await serviceCreatePortion(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingPortion');
		throw new Error(errorMessage);
	}
};

const updatePortion = async (data: IUpdatePortion) => {
	try {
		await serviceUpdatePortion(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingPortion');
		throw new Error(errorMessage);
	}
};

const getDishRestaurantPortions = async (args: IGetDishRestaurantPortionsArguments) => {
	try {
		const response = await serviceGetDishRestaurantPortions(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const toggleDishPortionsEnabled = async (data: IToggleDishPortionsEnabledArguments) => {
	try {
		await serviceToggleDishPortionsEnabled(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingPortion');
		throw new Error(errorMessage);
	}
};

const deletePortion = async (args: IDeleteDishPortionArguments) => {
	try {
		await serviceDeletePortion(args);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingPortion');
		throw new Error(errorMessage);
	}
};

const getPortionPositionList = async (args: IGetPortionPositionListArguments) => {
	try {
		const response = await serviceGetPortionPositionList(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getPortionPositionChains = async (args: IGetPortionPositionListArguments) => {
	try {
		const response = await serviceGetPortionPositionChains(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const updatePortionPositions = async (data: IUpdatePortionPositions) => {
	try {
		await serviceUpdatePortionPositions(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingPortionPositions');
		throw new Error(errorMessage);
	}
};

const getDishPhotos = async (args: { ids: string[]; size: 1 | 2 | 3 }) => {
	try {
		const response = await serviceGetDishPhotos(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

export {
	getDishInfo,
	getDishInfoV2,
	getDishesShortBySubCategoryId,
	getDishesShortBySubCategoryIdV2,
	getDishesShortBySubCategoryIds,
	getDishesShortByCustomerId,
	getDishesShortByRestaurantId,
	getDishesByRestaurantIdsAndSubcategoryIds,
	createDish,
	createDishV2,
	updateDish,
	updateDishV2,
	getPaginatedDishes,
	getPaginatedDishesByCustomerV2,
	getPaginatedDishesByRestaurantV2,
	deleteDish,
	deleteDishV2,
	getDishPositionList,
	getDishPositionListV2,
	getDishPositionChains,
	getDishPositionChainsV2,
	updateDishPositions,
	updateDishPositionsV2,
	getDishRestaurantProperties,
	updateDishRestaurantProperties,
	updateDishRestaurantPropertiesAsPatch,
	getPaginatedDishesForAssign,
	getPaginatedDishesForAssignV2,
	getListRestaurantsForAssignDishes,
	getListRestaurantsForAssignDishesV2,
	getCategoriesByIDRestaurantForAssignDishes,
	getCategoriesByIDRestaurantForAssignDishesV2,
	getSubcategoriesByIDsCategoriesForAssignDishes,
	getSubcategoriesByIDsCategoriesForAssignDishesV2,
	getDishesByIDsSubcategoriesForAssignDishes,
	getDishesByIDsSubcategoriesForAssignDishesV2,
	assignDish,
	assignDishV2,
	assignDishToSubcategories,
	assignDishToSubcategoriesValidate,
	updateRestaurantsInDish,
	getDishPortionInfo,
	createPortion,
	getDishRestaurantPortions,
	toggleDishPortionsEnabled,
	deletePortion,
	updatePortion,
	getPortionPositionList,
	getPortionPositionChains,
	updatePortionPositions,
	getDishPhotos,
};
